import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import Shrink from './components/shrink.vue';
export type TransitionType = 'shrink';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    type: {}
  },
  setup(__props: any) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/24 14:35:20
 * @description: 动画过度组件
 */
const props = __props;
const View = computed(() => {
  switch (props.type) {
    case 'shrink':
      return Shrink;
    default:
      return 'shrink';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(View.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})